import {Button, Dropdown, Icon, Menu} from "antd";
import React from "react";
import {getRoleDescription} from "../utils";

export const RolePicker = ({value , roles , onChange}) => {
    return (<Dropdown
        placement={'bottomRight'}
        overlay={
            <Menu
                style={{
                    maxWidth: 350,
                }}
                sso-id="user-change-roles-menu"
            >
                {roles.map((item) => (
                    <Menu.Item onClick={() => onChange(item)}>
                        <div className="update-role-row">
                            <p className="role-name">
                        <span
                            style={{
                                color: item.id === value.id ? "#094A9F" : "inherit",
                            }}
                        >
                          {item.role}
                        </span>

                                <span>
                          {item.id == value.id && (
                              <Icon
                                  type="check"
                                  style={{
                                      fontSize: 11,
                                      color: "#094A9F",
                                  }}
                              />
                          )}
                        </span>
                            </p>
                            <p
                                style={{
                                    fontSize: 13,
                                    lineHeight: "16px",
                                }}
                            >
                                {item.description || getRoleDescription(item.id)}
                            </p>
                        </div>
                    </Menu.Item>
                ))}
            </Menu>
        }
        trigger={["click"]}
    >
        <Button
            style={{
                width: "100%",
                textAlign : "left"
            }}
            type="default"
            sso-id="user-change-roles-trigger"
        >
            {value.role}
            <Icon type="down"/>
        </Button>
    </Dropdown>)
}
